import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=4f1098a6&scoped=true"
import script from "./Volume.vue?vue&type=script&lang=js"
export * from "./Volume.vue?vue&type=script&lang=js"
import style0 from "./Volume.vue?vue&type=style&index=0&id=4f1098a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1098a6",
  null
  
)

export default component.exports